
import React from 'react';

export const PrinterIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    print
  </span>
);